<div class="app-documents-preview-box">
  <div class="app-documents-preview-box__top-decoration-line"></div>

  <div class="app-documents-preview-box__header">
    <div class="app-documents-preview-box__header__actions">
      <div
        *ngIf="shouldShowDeleteButton"
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipPlacement="top"
        nzTooltipOverlayClassName="normalize"
        [nzTooltipTitle]="'BUTTON.DELETE' | translate"
        class="app-documents-preview-box__header__actions__delete-button"
        (click)="onDeleteDocument()"
      >
        <img src="assets/icons/icon_trash.svg" alt="delete" />
      </div>

      <div
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipPlacement="top"
        nzTooltipOverlayClassName="normalize"
        [nzTooltipTitle]="'BUTTON.DOWNLOAD' | translate"
        class="app-documents-preview-box__header__actions__download-button"
        (click)="onDownloadDocument()"
      >
        <img src="assets/icons/icon_download_gray_md.svg" alt="download" />
      </div>
    </div>

    <div class="app-documents-preview-box__header__navigation">
      <div
        [ngClass]="{ disabled: isFirstPreviewedDocument }"
        class="app-documents-preview-box__header__navigation__left-button"
        (click)="onNavigate('left')"
      >
        <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="left" />
      </div>
      <div
        [ngClass]="{ disabled: isLastPreviewedDocument }"
        class="app-documents-preview-box__header__navigation__right-button"
        (click)="onNavigate('right')"
      >
        <img src="assets/icons/icon_arrow_left_sm_gray.svg" alt="right" />
      </div>
    </div>

    <div class="app-documents-preview-box__header__close-button" (click)="onClose()">
      <img src="assets/icons/icon_close_gray_sm.svg" alt="close button" />
    </div>
  </div>

  <div class="app-documents-preview-box__body">
    <div class="app-documents-preview-box__body__doc-preview">
      <div
        class="app-documents-preview-box__body__doc-preview__image"
        *ngIf="!!currentlyPreviewed && open"
        [style.background-image]="currentlyPreviewed?.url"
      ></div>
    </div>
  </div>
</div>

<a #downloadLink class="d-none" download></a>
